export { YourFeaturedNews } from './YourFeaturedNews';
